import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/transaction?page=1&maxData=99999999&platformId=' // (1) 목록 조회

const fetchKey = (page, pageSize) =>
	`/transaction?page=${page}&maxData=${pageSize}&platformId=`;

let swrData: any = getPersistData(KEY)

export function useCustomerList(platformId, teamId, responsibilityId, depositedAt, createdAt, assignedAt, updatedAt, customerName, tel, accessPathId, page = 1, pageSize = 10) {
	const { data: token } = useToken()
	const url = fetchKey(page, pageSize);

	const { data, mutate } = useSWR<any>(
		url + platformId + '&teamId=' + teamId + '&responsibilityId=' + responsibilityId + '&depositedAt=' + depositedAt + '&createdAt=' + createdAt + '&assignedAt=' + assignedAt + '&updatedAt=' + updatedAt + '&customerName=' + customerName + '&tel=' + tel + '&accessPathId=' + accessPathId,
		async () => {
			const response = await API.get(url + platformId + '&teamId=' + teamId + '&responsibilityId=' + responsibilityId + '&depositedAt=' + depositedAt + '&createdAt=' + createdAt + '&assignedAt=' + assignedAt + '&updatedAt=' + updatedAt + '&customerName=' + customerName + '&tel=' + tel + '&accessPathId=' + accessPathId, token + '', {})

			return {
				list: response.result?.result?.list,
				total: response.result?.result?.totalCount
			};

			// swrData = response.result?.result?.list
			//
			// return swrData
			// }catch(e){
			// 	swrData = []
			// 	return swrData
			// }
		},
		{ revalidateOnFocus: true }
	)

	return {
		customerList: data?.list,
		total: data?.total,
		mutate,
	}
}